var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExchangeTo = function SvgExchangeTo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.056 9.922 4.05 10c0 .342.27.623.618.662l.082.004h8.81l-2.304 2.197a.644.644 0 0 0-.058.88l.059.063c.252.24.649.259.923.055l.066-.055 3.497-3.333a.644.644 0 0 0 .059-.88l-.059-.062-3.496-3.336a.725.725 0 0 0-.99-.001.644.644 0 0 0-.06.88l.06.063 2.3 2.196H4.751a.689.689 0 0 0-.695.589Z",
    fill: "#666"
  })));
};
export default SvgExchangeTo;